import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ErisFormFieldType } from 'eris-forms';
import { first } from 'rxjs/operators';
import PhoneNumberCountryCodes from './international-phone-numbers'

@Component({
  selector: 'app-international-phone',
  templateUrl: './international-phone.component.html',
  styleUrls: ['./international-phone.component.css']
})
export class InternationalPhoneComponent extends ErisFormFieldType implements OnInit, AfterViewInit {

  public phone: string = '';
  public countryCode:  string= '';
  public phonesCountryCode = PhoneNumberCountryCodes;
  public required = false;
  public editing = false;
  public isDataFilled = false;
  public disabled = false;

  constructor(private cdr: ChangeDetectorRef) { 
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(()=> {
      this.required = this.field.templateOptions.required;
      this.editing = this.field.templateOptions.editing;
      this.isDataFilled = this.field.templateOptions.isDataFilled;
      this.disabled = this.field.templateOptions.disabled;
      if(this.editing || this.isDataFilled){
        this.field.formControl.valueChanges.pipe(first(val => val != null)).subscribe((val) => {
          this.phonesCountryCode.forEach(phone => {
            if(val.slice(0,phone.code.length) == phone.code)
            {
              this.countryCode = phone.code;
              this.phone = val.substr(phone.code.length, val.length);
            }
        });
        });
      } else {
        this.countryCode = this.phonesCountryCode.find(p => p.countryCode == 'ET').code;
      }
      
      //international phone number pattern => [+ (1-4 country code) (9 - 12 number)]
      if(!this.field.templateOptions.dependsOnField){
        if(this.required){
          this.field.formControl.setValidators([Validators.required, Validators.pattern("\\+[0-9]{10,16}")]);       
        } else {
          this.field.formControl.setValidators([Validators.pattern("\\+[0-9]{10,16}")]);
        }
        this.field.formControl.updateValueAndValidity();

      } else {
        this.form.parent.get(this.field.templateOptions.dependsOnField)?.valueChanges.subscribe(() => {
          // need to wait for required option to be updated
          setTimeout(() => {
            this.required = this.field.templateOptions.required;
            if(!this.required){
              this.field.formControl.setValidators([Validators.pattern("\\+[0-9]{10,16}")]);
              this.phone = null;
              this.countryCode = null;
              this.field.formControl.setValue(null);
            }else {
              this.field.formControl.setValidators([Validators.required, Validators.pattern("\\+[0-9]{10,16}")]); 
            }
            this.field.formControl.updateValueAndValidity();
            this.cdr.detectChanges();
          }, 100);
        })
      }
    }) 
  }

  saveInput(){
    this.formControl.setValue(this.countryCode + this.phone);
  }
}
